import { makeStyles } from "@material-ui/core"

export default makeStyles(theme => ({
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        minHeight: 450
    },
    capitalized: {
        textTransform: "uppercase"
    },
    userInfoBox: {
        width: "50%"
    },
    list: {
        marginBottom: 8,
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row"
    },
    contactText: {
        paddingLeft: "16px"
    }
}))
